<template>
  <div class="position-relative">
    <div :class="{ 'content-placeholder__content--loading': showPlaceholder, 'content-placeholder__content': !showPlaceholder }">
      <template v-if="lazyLoad">
        <slot name="default" v-if="!props.value || props.loaded"/>
      </template>
      <template v-else>
        <slot name="default"/>
      </template>
      <s-ui-block :value="props.value && props.loaded"/>
    </div>
    <transition mode="out-in" name="fade-placeholder">
      <div :class="{ 'content-placeholder__placeholder--loading': showPlaceholder, 'content-placeholder__placeholder': !showPlaceholder }" v-show="showPlaceholder">
        <slot name="placeholder"/>
        <div class="ui-block ui-block__loader">
          <div class="spinner-border" role="status"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    value: {
      type: Boolean,
      default: false,
    },
    inPlace: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    lazyLoad: {
      type: Boolean,
      default: true,
    },
    forceLoader: {
      type: Boolean,
      default: false,
    },
  });

  const showPlaceholder = computed(() => props.value && !props.loaded || props.value && props.forceLoader);
</script>


